import { FormEvent } from 'react';
import { IDonorRegistration } from '@nkr/models/index';
import { Alert, Button, Col, ControlLabel, Form, FormControl, FormGroup, Modal, Row } from 'react-bootstrap'

interface IProps {
    show: boolean,
    formData: IDonorRegistration,
    arrivalDate: string,
    onDateChange: (arrivalDate: string) => void,
    onConfirm: () => void,
    onCancel: () => void
}

const MarkJugArrivedSendEmail = (props: IProps) => {
    const handleArrivalDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        props.onDateChange(e.currentTarget.value);
    };

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                Mark Jug Arrived / Send Email
            </Modal.Header>
            <Modal.Body>
                {props.formData &&
                    <div style={{ marginBottom: 20, textAlign: 'center' }}>
                        Mark jug as <strong>Arrived</strong> for donor <strong>{props.formData.firstName + ' ' + props.formData.lastName}</strong> by updating the field below:
                    </div>
                }

                <Form horizontal>
                    <FormGroup>
                        <Col xs={4} componentClass={ControlLabel}>
                            Arrival Date:
                        </Col>
                        <Col xs={6}>
                            <FormGroup>
                                <FormControl
                                    className='input-group'
                                    type='date'
                                    id='date'
                                    name='jugArrivalDate'
                                    value={props.arrivalDate}
                                    onChange={handleArrivalDateChange}
                                />
                            </FormGroup>
                        </Col>
                    </FormGroup>
                </Form>

                <Alert bsStyle='warning'>
                    By clicking this confirmation you will mark the jug as arrived and send out the e-mail
                    the candidate should have received when the jug arrived.
                </Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirm}>Mark Arrived</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default MarkJugArrivedSendEmail;